// extracted by mini-css-extract-plugin
module.exports = {"Stats":"Stats_Stats__26yoN","Overlay":"Stats_Overlay__3zPRO","Content":"Stats_Content__18eYK","Row":"Stats_Row__2BEEV","Stat":"Stats_Stat__3hfM4"};